import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import VerificationFunctionsService from '../../components/services/VerificationFunctionsService';

const useVerificationFunctionsService = () => {
  return useMemo(() => new VerificationFunctionsService(new ApiCalls()), []);
};

export default useVerificationFunctionsService;
